var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2932 19.9053C24.2306 20.8427 24.2306 22.3614 23.2932 23.2988C22.8282 23.7675 22.2133 24 21.5983 24C20.9834 24 20.3699 23.7656 19.9019 23.2969L11.9991 15.3982L4.09693 23.2951C3.62822 23.7675 3.01401 24 2.39981 24C1.78561 24 1.17216 23.7675 0.70307 23.2951C-0.234357 22.3576 -0.234357 20.839 0.70307 19.9016L8.60745 11.9972L0.70307 4.09656C-0.234357 3.15913 -0.234357 1.6405 0.70307 0.70307C1.6405 -0.234357 3.15913 -0.234357 4.09655 0.70307L11.9991 8.6112L19.9034 0.70682C20.8409 -0.230607 22.3595 -0.230607 23.2969 0.70682C24.2344 1.64425 24.2344 3.16288 23.2969 4.1003L15.3925 12.0047L23.2932 19.9053Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.233e38c931a9b4ae99bc63515e441809.svg";
export { ForwardRef as ReactComponent };